const initialState = {
    workstations: []
}

const SET_WORKSTATIONS = "PRODUCTION_OPTIONS/SET_WORKSTATIONS";

export const setWorkstations = (workstations) => ({
    type: SET_WORKSTATIONS,
    workstations
})

export default function reducer(state = initialState, action){
    switch(action.type){
        case SET_WORKSTATIONS: {
            return {
                ...state,
                workstations: action.workstations
            }
        }
        default: {
            return state;
        }
    }
}